import axios from "lib/axios";

export const getBuildingStructuresApi = async(buildingId) => {
  return await axios.get(`/api/buildings/${buildingId}/building_structures`);
}
